





























import { Component, Prop, Emit, Vue } from "vue-property-decorator";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";

@Component({
  components: {
    ButtonComponent
  }
})
export default class MultiMailComponent extends Vue {
  @Prop()
  id!: string;

  @Prop({
    default: false
  })
  hasError!: boolean;

  @Prop({ default: true })
  titleShow!: boolean;

  @Prop({
    default: function() {
      return [""];
    }
  })
  values!: Array<string>;

  // 2021.08.24 追加ボタンがデフォルトでは非表示になるよう修正
  @Prop({ default: true })
  addBtnShow!: boolean;

  @Emit()
  change(value: Array<string>): Array<string> {
    return value;
  }

  @Emit()
  addInput() {
    return "";
  }

  get internalValues() {
    return this.values;
  }

  set internalValues(values: Array<string>) {
    this.change(values);
  }
}
